
import React, { useEffect, useContext, useState } from "react";
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import '../index.css';
import { AuthContext } from "../context/AuthContext";

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { setUser, setToken, setMagazine } = useContext(AuthContext);
  const navigate = useNavigate();


  // const [email, setEmail] = useState('');
  // const [password, setPassword] = useState('');
  // const [error, setError] = useState('');
  // const [loading, setLoading] = useState(true);
  // const navigate = useNavigate();


  const handleLogin = async (e) => {
    e.preventDefault();
    try {

      const response = await authService.login({ email, password });
      var responseValue = await response.json();

      if (response.ok && responseValue.token) {
        // Save in localStorage
        localStorage.setItem('token', responseValue.token);
        localStorage.setItem('user', JSON.stringify(responseValue.user));
        localStorage.setItem('magazine', JSON.stringify(responseValue.user.magazines[0]));

        // Update context
        setToken(responseValue.token);
        setUser(responseValue.user);
        setMagazine(responseValue.user.magazines[0]);

        navigate('/dashboard');
      } else {
        setError(responseValue.message || 'Invalid credentials');
      }

      // localStorage.removeItem('token');
      // localStorage.removeItem('user');
      // localStorage.removeItem('magazine');

      // if (response.ok) {
      //   if (response.status === 200) {
      //     if (responseValue.token) {
      //       localStorage.setItem('token', responseValue.token);
      //       localStorage.setItem('user', JSON.stringify(responseValue.user));
      //       localStorage.setItem('magazine', JSON.stringify(responseValue.user.magazines[0]));

      //       navigate('/dashboard');
      //       // setError("Access denied. Please check your credentials.");
      //       setLoading(false);
      //     } else {
      //       setError(response.message || 'Invalid credentials');
      //     }
      //   } else if (response.status === 401) {
      //     setError("Unauthorized. Please login again.");
      //   } else {
      //     setError("Login failed. Please try again.");
      //   }
      //   return;
      // }
    } catch (err) {
      console.log(err);
      setError('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="login-container">
      <div className="wrappper">
        <img src="/logo.png" alt="Logo" className="logo" width={300}/>
        <h2>Login to Your Account</h2>
        {error && <p className="error-message">{error}</p>}
        <form onSubmit={handleLogin}>
          <label>Email</label>
          <input
            type="text"
            placeholder="Enter Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <label>Password</label>
          <input
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <p className="forgot-password">Forgot Password? <a href="/reset">Reset Password</a></p>
          <button type="submit" className="login-btn"><span>Sign In</span> <img src='/signin.png' /></button>
        </form>
      </div>
    </div>
  );
};

export default Login;
